import React, { useContext, useState } from "react";
import { AiOutlineMenu } from "react-icons/ai";
import { Link, useLocation, useNavigate } from "react-router-dom";
import classes from "./Navbar.module.css";
import { SidebarData } from "../../../Data/Constants/SidebarData";
import { MdManageAccounts } from "react-icons/md";
import { HiOutlineClipboardList } from "react-icons/hi"; // For pickup orders icon
import UserContext from "../../../Context/UserContext";

const Navbar = ({ data, setSideToggle }) => {
  const { user } = useContext(UserContext);
  const userEmail = sessionStorage.getItem("email");
  const { setIsLoggedIn, roles, userRole, specialAccess } = data;
  const navigate = useNavigate();
  const { pathname } = useLocation();

  // ✅ DEBUG: Log special access data
  console.log("🔍 Navbar Debug:");
  console.log("- userEmail:", userEmail);
  console.log("- specialAccess:", specialAccess);
  console.log("- userRole:", userRole);

  const logoutFunction = () => {
    sessionStorage.removeItem("token");
    setIsLoggedIn(false);
    navigate("login");
  };

  // State to keep track of the currently opened subnav
  const [activeSubNav, setActiveSubNav] = useState(null);

  // Handle the subnav visibility state
  const handleSubNav = (index) => {
    setActiveSubNav((prevIndex) => (prevIndex === index ? null : index));
  };

  const SidebarItem = ({ item, index }) => {
    const isSubNavActive = activeSubNav === index;
    const isActiveRoute = pathname === item.path;

    const navItemClass = `${classes.nav_text} ${
      isActiveRoute ? classes.active : ""
    }`;

    if (item.subNav) {
      // Check if the top-level item is allowed
      if (!roles[userRole]?.includes(item.path)) {
        return null;
      }

      return (
        <li key={index} className={classes.dropdown_item}>
          <div
            onClick={() => handleSubNav(index)}
            className={classes.main_link}
          >
            <div>
              {item.icon}
              <span>{item.title}</span>
            </div>
            <div className={classes.rightIcon}>
              {isSubNavActive ? item.iconOpened : item.iconClosed}
            </div>
          </div>
          <div>
            {isSubNavActive &&
              item.subNav.map((i, subIndex) => {
                return (
                  roles[userRole]?.includes(i.path) && (
                    <div key={subIndex} className={classes.nav_text}>
                      <div className={classes.dropdown_links}>
                        <Link
                          to={i.path}
                          className={pathname === i.path ? classes.active : ""}
                        >
                          {i.icon}
                          <span>{i.title}</span>
                        </Link>
                      </div>
                    </div>
                  )
                );
              })}
          </div>
        </li>
      );
    } else {
      // Only render the item if it is allowed for the user's role
      if (roles[userRole]?.includes(item.path)) {
        return (
          <li key={index} className={navItemClass}>
            <Link to={item.path} className={classes.main_link}>
              <div>
                {item.icon}
                <span>{item.title}</span>
              </div>
            </Link>
          </li>
        );
      } else {
        return null;
      }
    }
  };

  // ✅ NEW: Special Access Items Component
  const SpecialAccessItems = () => {
    if (!specialAccess || !specialAccess.additionalRoutes.length) {
      return null;
    }

    return (
      <>

        {/* ✅ Special Access Items */}
        {specialAccess.additionalRoutes.includes('/pickupOrders') && (
          <li 
            className={`${classes.nav_text} ${classes.specialAccessItem} ${
              pathname === '/pickupOrders' ? classes.active : ""
            }`}
          >
            <Link to="/pickupOrders" className={classes.main_link}>
              <div>
                <HiOutlineClipboardList className={classes.specialAccessIcon} />
                <span>Pickup Orders</span>
              </div>
            </Link>
          </li>
        )}

        {/* ✅ User Info for Special Access */}
        <li className={classes.specialAccessInfo}>
          <div className={classes.specialUserInfo}>
            <small>Special access for {userEmail?.split("@")[0]}</small>
          </div>
        </li>
      </>
    );
  };

  const showSidebar = () => {
    setSideToggle((prevValue) => !prevValue);
  };

  return (
    <>
      <div className={classes.navbar}>
        <nav>
          <Link to="#" className={classes.menu_bars}>
            <AiOutlineMenu style={{ color: "white" }} onClick={showSidebar} />
          </Link>
        </nav>
        <Link to="/" className={classes.logoLink}>
          <img
            src="/Firebrand_Logo_18.png"
            alt="Firebrand ERP"
            className={classes.logo}
          />
        </Link>
        <div className={classes.nav_end}>
          <MdManageAccounts className={classes.nav_end_icon} />
          <Link to="./user" className={classes.userLink}>
            <p>
              Hi, {userEmail?.split("@")[0] ?? "User"}
              {/* ✅ Show special access indicator in header */}
              {specialAccess && (
                <span className={classes.specialAccessHeaderBadge}>🔑</span>
              )}
            </p>
          </Link>
          <div className={classes.logoutLink} onClick={logoutFunction}>
            Logout
          </div>
        </div>
      </div>

      <nav
        className={
          data.sideToggle ? classes.nav_menu_active : classes.nav_menu
        }
      >
        <ul className={classes.nav_menu_items}>
          {/* ✅ Regular Sidebar Items */}
          {SidebarData.map((item, index) => (
            <SidebarItem item={item} index={index} key={index} />
          ))}
          
          {/* ✅ Special Access Items - Integrated into sidebar */}
          <SpecialAccessItems />
        </ul>
      </nav>
    </>
  );
};

export default Navbar;

// if (props.data.activeuser === 'User') {
//     if (
//       item.path === '/stockControl' ||
//       item.path === '/shipments' ||
//       item.path === '/reports'
//     ) {
//       return null;
//     } else {
//       <li key={index} className={classes.nav_text}>
//         <Link to={item.path}>
//           {item.icon}
//           <span>{item.title}</span>
//         </Link>
//       </li>;
//     }
//   }
//   return (
//     <li key={index} className={classes.nav_text}>
//       <Link to={item.path}>
//         {item.icon}
//         <span>{item.title}</span>
//       </Link>
//     </li>
//   );
